<script setup>
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { task, callback } = defineProps({
    task: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function toggleAction() {
    loading.value = true;

    axios
        .post(
            route('front.projectManagement.task.postToggleApikomTaskOnHold', {
                task: task.id,
            }),
        )
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .finally(() => {
            loading.value = false;
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="toggleAction" :loading="loading" />
</template>
